import { SaleTypeForTerm } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

/**
 * ディスカウントの利用可能期間に関する選択肢
 */
export const SaleTypeForTermOptions = [
	{ id: `Discount_SaleTypeForTerm_${SaleTypeForTerm.Always}`, label: "常に販売", value: SaleTypeForTerm.Always },
	{
		id: `Discount_SaleTypeForTerm_${SaleTypeForTerm.Limited}`,
		label: "期間を限定して販売",
		value: SaleTypeForTerm.Limited,
	},
] satisfies FormOptionType[];
